export default __webpack_public_path__ + "static/media/dog.2045aed2.png";